import { InfoCardV2Props } from 'components/CardBuilder/InfoCardV2';
import renderRichText from 'utils/contentful/renderRichText';
import { Section } from 'utils/types/contentfulTypes';

export const parseInfoCardV2 = (card: Section): InfoCardV2Props => {
  const { body, metadata } = card;

  return {
    text: {
      content: body && renderRichText(body),
      color: metadata?.theme?.textColor,
    },
    footnote: {
      content: metadata?.description?.description ?? '',
      color: metadata?.theme?.secondaryColor,
    },
    highlightTextColor: metadata?.theme?.tertiaryColor,
    desktopWidth: metadata?.context?.info_card_width ?? 'md',
    backgroundColor: metadata?.theme?.backgroundColor,
  };
};
